/**
 * Where the web walk keeps photos not sent yet (lib/walkUploads.ts): IndexedDB "cc-walk-photos", a list per business and person
 * (META, key "<org>|<email>") and the photo bytes (BLOBS, key "<org>|<email>|<ref>"). Kept tiny and apart so sign-out (auth.tsx)
 * can clear a person's photos without loading the walk.
 */
export const WALK_PHOTO_DB = "cc-walk-photos", META = "meta", BLOBS = "blobs";
/** auth.tsx says a person signed out; an open walk queue of theirs empties itself (walkUploads.ts). */
export const WALK_PHOTOS_CLEAR_EVENT = "cc:walk-photos-clear";

export function openDb(): Promise<IDBDatabase> {
  return new Promise((ok, no) => {
    const r = indexedDB.open(WALK_PHOTO_DB, 1);
    r.onupgradeneeded = () => { r.result.createObjectStore(META); r.result.createObjectStore(BLOBS); };
    r.onsuccess = () => ok(r.result);
    r.onerror = () => no(r.error);
  });
}
export function req<T>(db: IDBDatabase, store: string, mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest): Promise<T> {
  return new Promise((ok, no) => { const r = fn(db.transaction(store, mode).objectStore(store)); r.onsuccess = () => ok(r.result as T); r.onerror = () => no(r.error); });
}

/**
 * Sign-out: this person's unsent walk photos leave this browser, in every business (the open queue empties on the event; IndexedDB
 * loses their lists and bytes). Another person's photos on the same browser stay. Never throws.
 */
export async function clearWalkPhotosOf(who: string): Promise<void> {
  const me = who.trim().toLowerCase();
  if (!me) return;
  try { window.dispatchEvent(new CustomEvent(WALK_PHOTOS_CLEAR_EVENT, { detail: me })); } catch { /* no window */ }
  if (typeof indexedDB === "undefined") return;
  try {
    const d = await openDb();
    for (const k of await req<IDBValidKey[]>(d, META, "readonly", (s) => s.getAllKeys())) if (String(k).endsWith(`|${me}`)) await req(d, META, "readwrite", (s) => s.delete(k));
    for (const k of await req<IDBValidKey[]>(d, BLOBS, "readonly", (s) => s.getAllKeys())) if (String(k).includes(`|${me}|`)) await req(d, BLOBS, "readwrite", (s) => s.delete(k));
  } catch { /* nothing here to clear */ }
}
